@if (isFirstTimeAcceptance) {
  <sbb-dialog-title i18n="@@GTC_TITLE" class="cd-text-bold">AGB</sbb-dialog-title>
} @else {
  <sbb-dialog-title i18n="@@GTC_TITLE_UPDATED" class="cd-text-bold">Aktualisierung der AGB</sbb-dialog-title>
}

<sbb-dialog-content>
  @if (isFirstTimeAcceptance) {
    <p i18n="@@GTC_INTRO" class="m-no-t">Guten Tag,</p>
    <p i18n="@@GTC_INTRO_SUBTITLE" class="m-no-t"></p>
  } @else {
    <p i18n="@@GTC_INTRO_UPDATED" class="m-no-t">Guten Tag,</p>
    <p i18n="@@GTC_INTRO_SUBTITLE_UPDATED" class="m-no-t">
      unsere allgemeinen Geschäftsbedingungen wurden aktualisiert und benötigen nun Ihre Aufmerksamkeit.
    </p>
  }

  @if (isFirstTimeAcceptance) {
    <p i18n="@@GTC_DESCRIPTION">
      Damit Sie Cargo Digital nutzen können, brauchen wir Ihre Zustimmung zu unseren Allgemeinen Geschäftsbedingungen. Bitte akzeptieren Sie diese um
      fortzufahren. Gerne beantworten wir allfällige Fragen per E-Mail.
    </p>
  } @else {
    <p i18n="@@GTC_DESCRIPTION_UPDATED">
      Damit Sie Cargo Digital weiterhin wie gewohnt nutzen können, brauchen wir Ihre Zustimmung. Gerne beantworten wir allfällige Fragen per E-Mail.
    </p>
  }

  <sbb-link href="https://www.sbbcargo.com/de/kundencenter/dokumente/agb-recht.html" i18n-href="@@GTC_LINK" i18n="@@GTC_DOWNLOAD" class="m-inner-t">
    zu den AGB & Vertragsanlagen
  </sbb-link>
  <br />
  <sbb-link
    href="https://www.sbbcargo.com/de/meta/legallines/datenschutz.html"
    i18n-href="@@USER_PROFILE_PRIVACY_POLICY_LINK"
    i18n="@@USER_PROFILE_PRIVACY_POLICY_TITLE">
    Datenschutzerklärung
  </sbb-link>
</sbb-dialog-content>
<sbb-dialog-actions>
  <sbb-button (click)="acceptTermsAndConditions()" cdkFocusInitial iconName="arrow-right-small">
    @if (isFirstTimeAcceptance) {
      <ng-container i18n="@@GTC_ACCEPT">AGB akzeptieren und fortfahren</ng-container>
    } @else {
      <ng-container i18n="@@GTC_ACCEPT_UPDATED">Neue AGB akzeptieren und fortfahren</ng-container>
    }
  </sbb-button>
  <sbb-secondary-button i18n="@@GTC_LOGOUT" (click)="logout()">Abmelden</sbb-secondary-button>
</sbb-dialog-actions>
